import React, { Component, lazy, Suspense, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import mixins from "./mixins";
import Layout from "./layout";
import AdminLayout from "./layout/admin";
import "./App.scss";
import routemap from "./routes/routemap";
import { data } from "jquery";
const Navigate = (props) => {
	let navigate = useNavigate();
	window.navigate = (...args) => {
		navigate(...args);
	};
	return props.children;
};

const INACTIVITY_TIMEOUT_MS = 60 * 60 * 1000; // 1 hour
const LAST_ACTIVE_KEY = "last_active_time";

class App extends Component {
	constructor(props) {
		super(props);
		props.initialconstruct.bind(this)("app");
		this.store([
			{ name: 'requests', value: [] },
		]);
		this.state = {
			CustomLayout: AdminLayout
		};
		this.inactivityInterval = null;
		this.lastRecordedActivity = 0;
	}

	get isMobileVerified() {
		return localStorage.getItem('is_mobile_verified') == 'undefined' ? localStorage.getItem('is_mobile_verified') : JSON.parse(localStorage.getItem('is_mobile_verified'));
	}
	get currentpath() { return window.location.pathname; }
	get invoiceId() { return window?.app?.props?.urlparams?.invoice_id; }
	get token() { return this.props.store.auth; }
	get page() { return routemap.find(o => o.path === window.location.pathname || window.location.pathname.includes(o.path)) || {}; }
	get redirectpath() {
		return this.token
			? "/dashboard"
			: "/open/login";
	}
	// get redirectpath() {
	// 	if (this.token && (this.isMobileVerified !== undefined ? this.isMobileVerified : true)) {
	// 		return "/dashboard";
	// 	  } else {
	// 		return "/open/login";
	// 	  }		  
	// }
	get canNavigate() { return this.redirectpath !== this.currentpath; }
	get configStyleVars() {
		let { config = {} } = this.props.store;
		let { colors = {} } = config;
		let configkeys = Object.except(config, ['colors']);
		let logopath = configkeys.logo == 'self' ? imagepaths.Applogo : configkeys.logo;
		configkeys.logo = `url(${logopath})`;
		this.stylevars = colors;
		this.stylevars = configkeys;
		return;
	}
	set stylevars(data) {
		Object.entries(data).map(([key, val]) => {
			document.body.style.setProperty("--" + key.snakeCase(), val);
		});
	}

	isTokenExpired(token) {
		if (!token || typeof token !== "string") return true;
		try {
			const cleanToken = token.replace(/^Bearer\s+/i, "").trim();
			const parts = cleanToken.split('.');
			if (parts.length !== 3) return false;
			let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
			while (base64.length % 4) {
				base64 += '=';
			}
			const payload = JSON.parse(atob(base64));
			if (!payload || !payload.exp) return false;
			return payload.exp * 1000 <= Date.now();
		} catch (e) {
			return false;
		}
	}

	isSessionExpired() {
		if (!this.token) return false;

		// 1. Check 1-hour inactivity timeout
		const lastActiveStr = localStorage.getItem(LAST_ACTIVE_KEY);
		if (lastActiveStr) {
			const lastActive = parseInt(lastActiveStr, 10);
			if (lastActive && (Date.now() - lastActive) > INACTIVITY_TIMEOUT_MS) {
				return true;
			}
		}

		// 2. Also check JWT exp if token has expiration
		if (this.isTokenExpired(this.token)) {
			return true;
		}

		return false;
	}

	recordActivity = () => {
		if (!this.token) return;
		const now = Date.now();
		if (now - this.lastRecordedActivity > 3000) {
			this.lastRecordedActivity = now;
			localStorage.setItem(LAST_ACTIVE_KEY, now.toString());
		}
	};

	handleUserInteraction = () => {
		if (!this.token) return;
		if (this.isSessionExpired()) {
			this.handleSessionExpired();
			return;
		}
		this.recordActivity();
	};

	handleWakeUpOrFocus = () => {
		if (!this.token) return;
		if (this.isSessionExpired()) {
			this.handleSessionExpired();
		}
	};

	handleSessionExpired() {
		if (this.inactivityInterval) {
			clearInterval(this.inactivityInterval);
			this.inactivityInterval = null;
		}
		localStorage.removeItem(LAST_ACTIVE_KEY);

		if (this.props.api && this.props.api.applogout) {
			this.props.api.applogout();
		} else if (window.app?.props?.api?.applogout) {
			window.app.props.api.applogout();
		}
		localStorage.clear();

		alert("Your session has expired due to 1 hour of inactivity. Please log in again.");
		window.location.href = "/open/login";
	}

	checkLogin() {
		let navigate = window.navigate || (() => (''));
		let isOpenPage = this.currentpath.startsWith('/open');

		// Check session expiration
		if (this.token && this.isSessionExpired()) {
			if (!isOpenPage) {
				this.handleSessionExpired();
				return;
			} else {
				localStorage.removeItem(LAST_ACTIVE_KEY);
				if (this.props.api && this.props.api.applogout) {
					this.props.api.applogout();
				} else if (window.app?.props?.api?.applogout) {
					window.app.props.api.applogout();
				}
				localStorage.clear();
			}
		} else if (this.token) {
			if (!localStorage.getItem(LAST_ACTIVE_KEY)) {
				localStorage.setItem(LAST_ACTIVE_KEY, Date.now().toString());
			}
		} else {
			localStorage.removeItem(LAST_ACTIVE_KEY);
		}

		let gaurded = this.page.gaurded;
		let isGarded = ([undefined].includes(gaurded) ? !isOpenPage : gaurded);
		let isAdminWithoutToken = !(!isOpenPage && this.token);
		let pageGardedWithoutToken = !(this.page && this.page.gaurded && this.token);
		let isUnAuthorized = isGarded ? (isAdminWithoutToken && pageGardedWithoutToken) : false;
		let isLoggedIn = this.token && (this.currentpath == "/open/login" || this.currentpath == "/open/tablelogin/login");
		let canNavigate = (isUnAuthorized || isLoggedIn) && this.canNavigate;
		//console.log("canNavigate",{canNavigate,isUnAuthorized, isGarded, pageGardedWithoutToken,isAdminWithoutToken});
		if (canNavigate) {
			if (isUnAuthorized) {
				window.location.href = this.redirectpath;
			} else {
				navigate(this.redirectpath);
			}
		}
	}

	getLayoutComponent(path) {
		let layoutName = this.currentpath.basename();
		// return AdminLayout
		if (layoutName == "open") {
			return Layout;
		} else {
			try {
				// console.log("require(`./layout/${layoutName}`)",layoutName,require(`./layout/${layoutName}`));
				return require(`./layout/${layoutName}`).default;
			} catch (err) {
				// console.log({err});
				return this.redirectpath == "/open/login" ? Layout : AdminLayout;
			}
		}
	}

	setConfigObject() {
		this.props.api.apiGetOrganisationConfig().then(data => {
			this.store("config", data);
		});
		let basename = window.app.currentpath.basename()
		if (app.props.store.user && basename == "admin") {
			// this.props.api.apiEmployeeDesignations();
			// this.props.api.apiBankList();
			// this.props.api.apiEmployeeDepartment();
			// this.props.api.apiEmployeeWorkLocation();
			// this.props.api.apiEmployeeHolidayList();
		}
	}

	componentDidMount() {
		this.setConfigObject();
		let CustomLayout = this.getLayoutComponent(window.location.pathname);
		this.setState({ CustomLayout });

		if (this.token && !localStorage.getItem(LAST_ACTIVE_KEY)) {
			localStorage.setItem(LAST_ACTIVE_KEY, Date.now().toString());
		}

		this.checkLogin();

		// Periodic check every 10 seconds for idle users on static pages (like dashboard)
		this.inactivityInterval = setInterval(() => {
			if (this.token && this.isSessionExpired()) {
				this.handleSessionExpired();
			}
		}, 10000);

		// Wake-up and tab focus listeners
		window.addEventListener("focus", this.handleWakeUpOrFocus);
		window.addEventListener("pageshow", this.handleWakeUpOrFocus);
		document.addEventListener("visibilitychange", this.handleWakeUpOrFocus);

		// User interaction listeners
		const activityEvents = ["click", "mousemove", "keydown", "scroll", "touchstart"];
		activityEvents.forEach((ev) => {
			window.addEventListener(ev, this.handleUserInteraction, true);
		});
	}

	componentWillUnmount() {
		if (this.inactivityInterval) {
			clearInterval(this.inactivityInterval);
		}
		window.removeEventListener("focus", this.handleWakeUpOrFocus);
		window.removeEventListener("pageshow", this.handleWakeUpOrFocus);
		document.removeEventListener("visibilitychange", this.handleWakeUpOrFocus);

		const activityEvents = ["click", "mousemove", "keydown", "scroll", "touchstart"];
		activityEvents.forEach((ev) => {
			window.removeEventListener(ev, this.handleUserInteraction, true);
		});
	}

	componentDidUpdate() {
		this.checkLogin();
		let pathname = window.location.pathname;
		if (pathname != window.activeRoute) {
			window.activeRoute = window.location.pathname;
			let CustomLayout = this.getLayoutComponent(window.location.pathname);
			this.setState({ CustomLayout });
			console.log({ pathname: window.location.pathname });
		}
	}



	render() {
		let { CustomLayout } = this.state;
		//console.log({CustomLayout});
		return (
			<Navigate>
				{this.configStyleVars}
				{
					CustomLayout && (
						<Suspense>
							<CustomLayout>
								{this.props.children}
							</CustomLayout>
						</Suspense>
					)
				}
			</Navigate>
		);
	}
}

export default connect(App);